import TrackingServicePageVisitDispatch from 'tracking_service_page_visit_dispatch';
import { getPageName } from 'utilities';

function newEventDispatcher() {
  return (new TrackingServicePageVisitDispatch(process.env.TRACKING_BASE_URL));
}

export function sendPageVisit() {
  newEventDispatcher().send(
    {
      url: window.location.href,
      referrer_url: document.referrer,
      page_name: getPageName()
    }
  )
}
